import React from 'react'

const PageContact = () => {
    return (
        <div>
            <h1>Fale Conosco</h1>
        </div>
    )
}

export default PageContact
